import * as Yup from 'yup';

const descriptionRequired = Yup.string()
  .trim()
  .min(5, 'Descreva com mais detalhes')
  .required('Informe a descrição');

export const createAdjustmentSchema = Yup.object({
  fromGroupId: Yup.number()
    .transform((value, original) =>
      original === '' || original == null ? undefined : Number(original)
    )
    .typeError('Informe o setor de origem')
    .required('Informe o setor de origem'),
  groupSlug: Yup.string().trim().required('Informe o setor destino'),
  reasonId: Yup.number().typeError('Informe o motivo').required('Informe o motivo'),
  description: descriptionRequired,
});

export const concludeAdjustmentSchema = Yup.object({
  description: descriptionRequired,
});

export const annulAdjustmentSchema = Yup.object({
  description: descriptionRequired,
});

export function parseYupErrors(err) {
  if (!err || !err.inner) return {};
  const out = {};
  err.inner.forEach((e) => {
    if (e.path && !out[e.path]) out[e.path] = e.message;
  });
  return out;
}

export function parseApiError(err, fallbackMessage = 'Falha ao processar a requisição.') {
  const data = err?.response?.data;
  let message = fallbackMessage;

  if (typeof data === 'string') {
    message = data;
  } else if (data) {
    if (typeof data.message === 'string') message = data.message;
    else if (typeof data.error === 'string') message = data.error;
    else if (typeof data.error?.message === 'string') message = data.error.message;
  }

  const fieldErrors = {};
  const errors = data?.errors || data?.error?.errors;
  if (errors && typeof errors === 'object') {
    Object.entries(errors).forEach(([k, v]) => {
      fieldErrors[k] = Array.isArray(v) ? v[0] : String(v);
    });
  }

  return { message, fieldErrors };
}
